import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { DeleteRegular } from "@fluentui/react-icons";

interface IDialogDeleteUserDocumentProps {
  open: boolean;
  onClose(): void;
  onDelete(): void;
}
function DialogDeleteUserDocument(props: IDialogDeleteUserDocumentProps) {
  return (
    <Dialog open={props.open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Benutzer löschen</DialogTitle>
          <DialogContent>
            Möchten Sie wirklich das Dokument löschen?
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                props.onDelete();
              }}
              appearance="primary"
              icon={<DeleteRegular />}
            >
              Löschen
            </Button>
            <Button onClick={() => props.onClose()}>Abbrechen</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default DialogDeleteUserDocument;
